const focusClass = 'ds-focus';

function removeFocus(event) {
  event.target.classList.remove(focusClass);
  event.target.removeEventListener('blur', removeFocus);
}

function handleTabMovement(event) {
  if (event.code === 'Tab') {
    const currentFocus = document.querySelector('.ds-focus');
    if (currentFocus) {
      currentFocus.classList.remove(focusClass);
    }

    setTimeout(() => {
      const element = document.activeElement;
      if (element.tabIndex < 0) { // When focusing an iframe, activeElement will be the body. We don't want overlay on body.
        return;
      }
      element.classList.add('ds-focus');
      element.addEventListener('blur', removeFocus);
    });
  }
}

function loadTabMovement() {
  document.addEventListener('keydown', handleTabMovement);
}

export default loadTabMovement;
